import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import "./../styles/contact.css";
import Maps from "../components/Maps";
import mapa from "../assets/images/contact/mapa.jpg"

const Contact = () => {
  const form = useRef();


  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">Onde Estamos</h2>
        <div className="contact-content">
          <div className="contact-info-box">
            <h3>Informações de Contato</h3>
            <p>
              Entre em contato pelo WhatsApp e agende o melhor momento para sua escuta.
            </p>
            <br />
            <ul>
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <p>Rua Antônio Carlos Tacconi, 261-A - Vila Santa Maria, São Paulo - SP, 04810-020</p>
                <br />
              </li>
              <li>
                <i className="fa-solid fa-phone"></i>
                <br />
                <p>11 99883-5125</p>
              </li>
              <li>
                <i className="fa-solid fa-envelope"></i>
                <br />
                <p>psicologomarcelo@hotmail.com</p>
              </li>
            </ul>
            {/* Aqui entra o calendário */}
            <li className="calendar-image">
            <div style={{ marginTop: "20px", padding: "12px", backgroundColor: "#f3f3f3", borderRadius: "8px", fontSize: "0.9rem", color: "#444" }}>
            <a
              href="https://wa.me/551198835125?text=Ol%C3%A1!%20Vim%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es."
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <i className="fa-solid fa-calendar-days" style={{ marginRight: "8px", color: "#25D366" }}></i>
              Agende o melhor momento para você. Estou aqui para te escutar.
            </a>

          </div>
            </li>
          </div>

          {/* Aqui entra a div com a imagem fixa */}
          <div className="contact-image-container">
            <img
              src={mapa} // Substitua pelo link da sua imagem
              alt="Imagem fixa"
              style={{ width: "100%", maxWidth: "900px", height: "auto", borderRadius: "8px" }}
            />
          </div>

          
        </div>
      </div>
    </section>
  );
};

export default Contact;
